
import { mapState } from 'vuex';
import { required } from '~/services/validators';
import submitAddressMixin from '~/mixins/submitAddress';

export default {
    name: 'WasteRemovalContactForm',
    mixins: [submitAddressMixin],
    props: {
        form: {
            type: Object,
            required: true,
        },
        isEditForm: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showAddAddress: null,
        };
    },
    async fetch() {
        await this.$store.dispatch('addresses/get');
        this.showAddAddress = !this.addresses.length;
    },
    computed: {
        ...mapState({
            addresses: (state) => state.addresses.data,
            auth: (state) => state.auth,
        }),
        showMobileNumber() {
            return !this.auth.user || !this.auth.user.mobile_number;
        },
    },
    created() {
        // eslint-disable-next-line camelcase
        this.form.addValidations({ mobile_number: this.auth?.user?.mobile_number ? [] : [required] });
    },
    methods: {
        async submit() {
            if (this.showMobileNumber && !this.form.validateFields(['mobile_number'])) {
                return;
            }
            if (this.showAddAddress) {
                /* eslint vue/no-mutating-props: 0 */
                // @todo fix this
                this.form.address.$model = null;
                if (this.form.validateFields(['addressLine1', 'postcode'])) {
                    this.useAddress({
                        address_1: this.form.addressLine1.$model,
                        house_name: this.form.houseName.$model,
                        postcode: this.form.postcode.$model,
                    });
                    const geocode = await this.geocode();
                    if (!geocode) {
                        return;
                    }
                } else {
                    return;
                }
            }
            this.$emit('submit');
        },
        selectAddress(address) {
            this.useAddress({
                id: address.id,
                address_1: address.address_1,
                house_name: address.house_name,
                postcode: address.postcode,
            });
        },
    },
};
